import type { CityTag, CountryTag, RegionTag } from '@/shared/api/experience';

type AnyTag = CityTag | RegionTag | CountryTag;
type RubricTitlesMap = Record<string, string>;

export function createRubricTitlesMap(tags: AnyTag[] | undefined): RubricTitlesMap {
  if (!tags || tags.length === 0) {
    return {};
  }

  return (tags ?? []).reduce<RubricTitlesMap>((map, tag) => {
    let slug: string | undefined;

    if ('tag_slug' in tag) {
      slug = tag.tag_slug;
    } else if ('slug' in tag) {
      slug = tag.slug;
    } else {
      slug = undefined;
    }

    const name = 'name' in tag ? tag.name : undefined;

    if (slug && name) {
      map[slug] = name;
    }

    return map;
  }, {});
}
